import { forwardRef } from 'react';
import { Tooltip } from 'src/components';
import { TooltipProps } from 'src/components/Tooltip/Tooltip';

export const WithTooltip = forwardRef(
  (
    {
      hideTooltip,
      children,
      ...props
    }: TooltipProps & {
      hideTooltip?: boolean;
    },
    ref,
  ) => {
    if (!hideTooltip) {
      return (
        <Tooltip {...props} ref={ref}>
          {children}
        </Tooltip>
      );
    }

    return children;
  },
);

WithTooltip.displayName = 'WithTooltip';
